// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"373":"accesos","728":"usuarios","913":"default"}[chunkId] || chunkId) + "-legacy." + {"373":"4c2518da","386":"fc35c6e8","728":"8ca93ee0","913":"cf40467d"}[chunkId] + ".js";
};